import { LayoutOptions } from '../../layouts';
import { HorizontalTemplate } from '../fields/ObjectFieldTemplate';
import { TableRowTemplate } from '../fields/ObjectFieldTemplate';
import { ArrayTableTemplate } from '../fields/ArrayFieldTemplate';

/**
 * Default set of scaffolder layout components, pre-assembled as LayoutOptions[].
 * Useful when rendering RJSF forms outside the scaffolder outlet context
 * (e.g. the Autofix drawer) where `useOutletLayouts` is not available.
 *
 * WittyTableTemplate and WittyTableRowTemplate are mapped to their non-Witty
 * equivalents (ArrayTableTemplate / TableRowTemplate) because the Witty
 * variants depend on WittyTableContextProvider / useWittyFormContext which are
 * only available inside the full scaffolder form pipeline.
 */
export const defaultScaffolderLayouts: LayoutOptions[] = [
  { name: 'HorizontalTemplate', component: HorizontalTemplate },
  { name: 'TableRowTemplate', component: TableRowTemplate },
  { name: 'ArrayTableTemplate', component: ArrayTableTemplate as any },
  { name: 'WittyTableTemplate', component: ArrayTableTemplate as any },
  { name: 'WittyTableRowTemplate', component: TableRowTemplate },
];
